import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="text-center">
        {/* SuperOwl Logo */}
        <div className="mb-8">
          <div className="inline-flex items-center">
            <div className="w-16 h-16 bg-gradient-to-r from-[#1d2840] to-[#3DA3DC] rounded-full flex items-center justify-center mr-4">
              <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
            </div>
            <div className="text-left">
              <span className="text-[#1d2840] font-bold text-4xl">Super</span>
              <span className="text-[#3DA3DC] font-bold text-4xl">Owl</span>
            </div>
          </div>
        </div>
        
        {/* Loading Spinner */}
        <div className="mb-6">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#3DA3DC] border-t-transparent mx-auto"></div>
        </div>
        
        {/* Loading Text */}
        <div className="space-y-2">
          <p className="text-[#1d2840] text-xl font-semibold">Loading SuperOwl</p>
          <p className="text-gray-600">Please wait while we prepare your AI assistant...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
